import PropTypes from 'prop-types';

var Variants;
(function (Variants) {
    Variants["DEFAULT"] = "default";
    Variants["ROUNDED"] = "rounded";
    Variants["FOCUSED"] = "focused";
})(Variants || (Variants = {}));
var propTypes = {
    variant: PropTypes.oneOf([Variants.DEFAULT, Variants.ROUNDED]),
    label: PropTypes.string,
    isValid: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    primaryCondition: PropTypes.string,
    secondaryCondition: PropTypes.string,
    placeholder: PropTypes.string,
    relativelyStyledConditions: PropTypes.bool,
    isMultilineSecondaryCondition: PropTypes.bool,
    clearable: PropTypes.bool,
    clearableAltText: PropTypes.string,
};
var defaultProps = {
    variants: Variants.ROUNDED,
    clearable: true,
    clearableAltText: 'Clear Input',
};

export { Variants, defaultProps, propTypes };
